import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_ctx.warning !== null)
    ? _withDirectives((_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["reuse-cap-badge ms-1", _ctx.evaluation.status === 'blocked' ? 'reuse-cap--blocked' : 'reuse-cap--partial']),
        title: _ctx.warning
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 16 16",
          fill: "currentColor",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.89 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
        ], -1)
      ]), 10, _hoisted_1)), [
        [
          _directive_b_tooltip,
          void 0,
          void 0,
          { hover: true }
        ]
      ])
    : _createCommentVNode("", true)
}